import type { FormField } from '@cli-types/core-engine/schema.js'

export function fieldContainerClass(height: FormField['height'], className = 'space-y-2'): string {
  if (height === 'fill') return `flex-1 min-h-0 ${className}`
  return className
}
